var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconClipboardPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 32,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.5001 13.284V24.3555M21.0358 18.8198H9.96436M18.8215 1.10547H12.1786C11.5914 1.10547 11.0282 1.33876 10.6129 1.75402C10.1976 2.16928 9.96436 2.73249 9.96436 3.31975V4.4269C9.96436 5.01416 10.1976 5.57737 10.6129 5.99263C11.0282 6.40789 11.5914 6.64118 12.1786 6.64118H18.8215C19.4088 6.64118 19.972 6.40789 20.3872 5.99263C20.8025 5.57737 21.0358 5.01416 21.0358 4.4269V3.31975C21.0358 2.73249 20.8025 2.16928 20.3872 1.75402C19.972 1.33876 19.4088 1.10547 18.8215 1.10547Z",
    stroke: "#367FFF",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5893 3.32031H24.9107C25.498 3.32031 26.0612 3.5536 26.4764 3.96886C26.8917 4.38412 27.125 4.94733 27.125 5.5346V27.6775C27.125 28.2647 26.8917 28.8279 26.4764 29.2432C26.0612 29.6584 25.498 29.8917 24.9107 29.8917H6.08929C5.50202 29.8917 4.93881 29.6584 4.52355 29.2432C4.10829 28.8279 3.875 28.2647 3.875 27.6775V5.5346C3.875 4.94733 4.10829 4.38412 4.52355 3.96886C4.93881 3.5536 5.50202 3.32031 6.08929 3.32031H9.41071",
    stroke: "#367FFF",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClipboardPlus);
export default __webpack_public_path__ + "static/media/icon-clipboard-plus.79b792ee2b68235f4c43f9266edc1d2f.svg";
export { ForwardRef as ReactComponent };